module.exports = __webpack_public_path__ + "img/hypergryph_yostar.8a25b9fc.png";